import React, { useMemo } from 'react';
import { HomePageLink } from '../../../HomePageLink';
import { DrawTable } from '@apply/ui';
import { applicationInsights } from '../../../ApplicationInsights';
import { FeatureType } from '@apply/constants';
import { useAuthentication } from '../../../LoginPage';
import '../../scss/_draw.scss';

export const DrawControl: React.FC = () => {
    const { isFeatureEnabled, authentication } = useAuthentication();
    const borrowerName = useMemo(() => `${authentication?.user?.firstName} ${authentication?.user?.lastName}`, [authentication]);

    const isInspectionsEnabled: boolean = useMemo(() => isFeatureEnabled(FeatureType.Inspections), [isFeatureEnabled]);

    return (
        <main>
            <div className='flex'>
                <div
                    className='main-content bfi-draw'
                    style={{ padding: 0, paddingLeft: 20 }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: 10,
                        }}
                    >
                        <div>
                            <div style={{ marginBottom: 10, paddingLeft: 20 }}>
                                <HomePageLink />
                            </div>
                            <DrawTable
                                applicationInsights={applicationInsights}
                                borrowerName={borrowerName}
                                isInspectionsEnabled={isInspectionsEnabled}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};
